import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=d2b64a8c"
import script from "./ViewForm.vue?vue&type=script&lang=js"
export * from "./ViewForm.vue?vue&type=script&lang=js"
import style0 from "./ViewForm.vue?vue&type=style&index=0&id=d2b64a8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports